import { PlanogramPlan, Milestone, Subtask, FileInfo } from '../types/index'

// Mock file data
export const mockFiles: FileInfo[] = [
  {
    fileId: 'file001',
    fileName: 'milestone_deliverable.pdf',
    fileSize: 1024000,
    fileType: 'application/pdf',
    uploadTime: new Date('2025-01-15T10:30:00'),
    uploadedBy: 'user001',
    downloadUrl: '/api/files/download/file001',
  },
  {
    fileId: 'file002',
    fileName: 'task_report.docx',
    fileSize: 512000,
    fileType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    uploadTime: new Date('2025-01-16T14:20:00'),
    uploadedBy: 'user002',
    downloadUrl: '/api/files/download/file002',
  },
]

// Comprehensive mock subtask data with proper parent-child relationships
export const mockSubtasks: Subtask[] = [
  // Subtasks for milestone001 (Data Collection and Analysis)
  {
    subtaskId: 'subtask001',
    milestoneId: 'milestone001',
    parentMilestone: 'milestone001',
    taskName: 'Product Data Collection and Organization',
    assignee: 'user001',
    creator: 'manager001',
    plannedHours: 16,
    actualHours: 14,
    status: 'Completed',
    startTime: new Date('2025-01-10T09:00:00'),
    endTime: new Date('2025-01-12T17:00:00'),
    remarks: 'Data collection completed with good quality',
    deliverableFiles: [mockFiles[0]],
  },
  {
    subtaskId: 'subtask002',
    milestoneId: 'milestone001',
    parentMilestone: 'milestone001',
    taskName: 'Sales Data Analysis',
    assignee: 'user002',
    creator: 'manager001',
    plannedHours: 24,
    actualHours: 22,
    status: 'Completed',
    startTime: new Date('2025-01-11T09:00:00'),
    endTime: new Date('2025-01-15T16:00:00'),
    remarks: 'Identified 3 key sales trends',
    deliverableFiles: [mockFiles[1]],
  },
  {
    subtaskId: 'subtask003',
    milestoneId: 'milestone001',
    parentMilestone: 'milestone001',
    taskName: 'Competitor Display Research',
    assignee: 'user003',
    creator: 'manager001',
    plannedHours: 8,
    actualHours: 8,
    status: 'Completed',
    startTime: new Date('2025-01-13T09:00:00'),
    endTime: new Date('2025-01-14T17:00:00'),
    remarks: 'Researched display methods of 5 competitors',
    deliverableFiles: [],
  },
  // Subtasks for milestone002 (Display Solution Design)
  {
    subtaskId: 'subtask004',
    milestoneId: 'milestone002',
    parentMilestone: 'milestone002',
    taskName: 'Display Design Drawing',
    assignee: 'user004',
    creator: 'manager002',
    plannedHours: 32,
    actualHours: undefined,
    status: 'InProgress',
    startTime: new Date('2025-01-17T09:00:00'),
    endTime: undefined,
    remarks: 'Design drawing 60% complete, expected to finish on time',
    deliverableFiles: [],
  },
  {
    subtaskId: 'subtask005',
    milestoneId: 'milestone002',
    parentMilestone: 'milestone002',
    taskName: 'Product Configuration Plan Development',
    assignee: 'user005',
    creator: 'manager002',
    plannedHours: 24,
    actualHours: undefined,
    status: 'InProgress',
    startTime: new Date('2025-01-18T09:00:00'),
    endTime: undefined,
    remarks: 'Confirming configuration details with product department',
    deliverableFiles: [],
  },
  {
    subtaskId: 'subtask006',
    milestoneId: 'milestone002',
    parentMilestone: 'milestone002',
    taskName: 'Display Standards Development',
    assignee: 'user006',
    creator: 'manager002',
    plannedHours: 16,
    actualHours: undefined,
    status: 'NotStarted',
    startTime: undefined,
    endTime: undefined,
    remarks: 'Need to reassess applicability of display standards',
    deliverableFiles: [],
  },
  // Subtasks for milestone003 (Solution Review and Optimization)
  {
    subtaskId: 'subtask007',
    milestoneId: 'milestone003',
    parentMilestone: 'milestone003',
    taskName: 'Internal Review Meeting Organization',
    assignee: 'user007',
    creator: 'manager003',
    plannedHours: 8,
    actualHours: undefined,
    status: 'NotStarted',
    startTime: undefined,
    endTime: undefined,
    remarks: 'Meeting room booked, need to prepare review materials',
    deliverableFiles: [],
  },
  {
    subtaskId: 'subtask008',
    milestoneId: 'milestone003',
    parentMilestone: 'milestone003',
    taskName: 'Expert Opinion Collection',
    assignee: 'user008',
    creator: 'manager003',
    plannedHours: 12,
    actualHours: undefined,
    status: 'NotStarted',
    startTime: undefined,
    endTime: undefined,
    remarks: 'Contacted 3 external experts, waiting for responses',
    deliverableFiles: [],
  },
  {
    subtaskId: 'subtask009',
    milestoneId: 'milestone003',
    parentMilestone: 'milestone003',
    taskName: 'Solution Optimization and Adjustment',
    assignee: 'user009',
    creator: 'manager003',
    plannedHours: 16,
    actualHours: undefined,
    status: 'NotStarted',
    startTime: undefined,
    endTime: undefined,
    remarks: 'Adjusting solution based on expert opinions',
    deliverableFiles: [],
  },
  // Subtasks for milestone004 (Material Preparation and Distribution)
  {
    subtaskId: 'subtask010',
    milestoneId: 'milestone004',
    parentMilestone: 'milestone004',
    taskName: 'Material Requirements List Development',
    assignee: 'user010',
    creator: 'manager004',
    plannedHours: 16,
    actualHours: undefined,
    status: 'NotStarted',
    startTime: undefined,
    endTime: undefined,
    remarks: 'Need to coordinate material list with procurement department',
    deliverableFiles: [],
  },
  {
    subtaskId: 'subtask011',
    milestoneId: 'milestone004',
    parentMilestone: 'milestone004',
    taskName: 'Supplier Coordination and Communication',
    assignee: 'user011',
    creator: 'manager004',
    plannedHours: 24,
    actualHours: undefined,
    status: 'NotStarted',
    startTime: undefined,
    endTime: undefined,
    remarks: 'Main supplier contact information updated',
    deliverableFiles: [],
  },
  {
    subtaskId: 'subtask012',
    milestoneId: 'milestone004',
    parentMilestone: 'milestone004',
    taskName: 'Distribution Plan Development',
    assignee: 'user012',
    creator: 'manager004',
    plannedHours: 20,
    actualHours: undefined,
    status: 'NotStarted',
    startTime: undefined,
    endTime: undefined,
    remarks: 'Considering holiday impact on distribution',
    deliverableFiles: [],
  },
  // Subtasks for urgent plan milestone010
  {
    subtaskId: 'subtask013',
    milestoneId: 'milestone010',
    parentMilestone: 'milestone010',
    taskName: 'Problem Product Identification',
    assignee: 'user013',
    creator: 'manager001',
    plannedHours: 4,
    actualHours: 3,
    status: 'Completed',
    startTime: new Date('2025-02-01T09:00:00'),
    endTime: new Date('2025-02-01T12:00:00'),
    remarks: 'Identified 5 problem products requiring urgent handling',
    deliverableFiles: [],
  },
  {
    subtaskId: 'subtask014',
    milestoneId: 'milestone010',
    parentMilestone: 'milestone010',
    taskName: 'Impact Scope Assessment',
    assignee: 'user014',
    creator: 'manager001',
    plannedHours: 4,
    actualHours: 4,
    status: 'Completed',
    startTime: new Date('2025-02-01T13:00:00'),
    endTime: new Date('2025-02-01T16:30:00'),
    remarks: 'Impact scope involves 15 stores',
    deliverableFiles: [],
  },
  // Subtasks for urgent plan milestone011
  {
    subtaskId: 'subtask015',
    milestoneId: 'milestone011',
    parentMilestone: 'milestone011',
    taskName: 'Emergency Removal Plan Development',
    assignee: 'user015',
    creator: 'manager002',
    plannedHours: 4,
    actualHours: 4,
    status: 'Completed',
    startTime: new Date('2025-02-02T09:00:00'),
    endTime: new Date('2025-02-02T13:00:00'),
    remarks: 'Plan approved by headquarters',
    deliverableFiles: [],
  },
  {
    subtaskId: 'subtask016',
    milestoneId: 'milestone011',
    parentMilestone: 'milestone011',
    taskName: 'Alternative Product Display Design',
    assignee: 'user016',
    creator: 'manager002',
    plannedHours: 4,
    actualHours: 4,
    status: 'Completed',
    startTime: new Date('2025-02-02T14:00:00'),
    endTime: new Date('2025-02-02T17:00:00'),
    remarks: 'Alternative product display effect is good',
    deliverableFiles: [],
  },
  // Subtasks for urgent plan milestone012
  {
    subtaskId: 'subtask017',
    milestoneId: 'milestone012',
    parentMilestone: 'milestone012',
    taskName: 'Emergency Task List Generation',
    assignee: 'user017',
    creator: 'manager009',
    plannedHours: 4,
    actualHours: undefined,
    status: 'InProgress',
    startTime: new Date('2025-02-03T09:00:00'),
    endTime: undefined,
    remarks: 'Task list under final confirmation',
    deliverableFiles: [],
  },
  {
    subtaskId: 'subtask018',
    milestoneId: 'milestone012',
    parentMilestone: 'milestone012',
    taskName: 'Store Notification Dispatch',
    assignee: 'user018',
    creator: 'manager009',
    plannedHours: 4,
    actualHours: undefined,
    status: 'NotStarted',
    startTime: undefined,
    endTime: undefined,
    remarks: 'Waiting for task list confirmation before sending',
    deliverableFiles: [],
  },
]

// Mock personnel data
export const mockPersonnel = [
  { id: 'user001', name: 'John Smith', department: 'Planogram Team', workload: 3, position: 'Display Specialist', email: 'john.smith@company.com' },
  { id: 'user002', name: 'Sarah Johnson', department: 'Planogram Team', workload: 2, position: 'Display Designer', email: 'sarah.johnson@company.com' },
  { id: 'user003', name: 'Michael Brown', department: 'Operations Team', workload: 4, position: 'Operations Specialist', email: 'michael.brown@company.com' },
  { id: 'user004', name: 'Emily Davis', department: 'Logistics Team', workload: 1, position: 'Logistics Specialist', email: 'emily.davis@company.com' },
  { id: 'user005', name: 'David Wilson', department: 'Training Team', workload: 2, position: 'Training Specialist', email: 'david.wilson@company.com' },
  { id: 'user006', name: 'Lisa Anderson', department: 'Data Team', workload: 3, position: 'Data Analyst', email: 'lisa.anderson@company.com' },
  { id: 'user007', name: 'Robert Taylor', department: 'IT Team', workload: 1, position: 'System Engineer', email: 'robert.taylor@company.com' },
  { id: 'user008', name: 'Jennifer Martinez', department: 'Planogram Team', workload: 2, position: 'Display Assistant', email: 'jennifer.martinez@company.com' },
  { id: 'user009', name: 'Christopher Garcia', department: 'Operations Team', workload: 3, position: 'Operations Supervisor', email: 'christopher.garcia@company.com' },
  { id: 'user010', name: 'Amanda Rodriguez', department: 'Logistics Team', workload: 2, position: 'Logistics Supervisor', email: 'amanda.rodriguez@company.com' },
  { id: 'user011', name: 'James Lopez', department: 'Procurement Team', workload: 4, position: 'Procurement Specialist', email: 'james.lopez@company.com' },
  { id: 'user012', name: 'Michelle Gonzalez', department: 'Procurement Team', workload: 3, position: 'Procurement Supervisor', email: 'michelle.gonzalez@company.com' },
  { id: 'user013', name: 'Daniel Perez', department: 'Quality Team', workload: 2, position: 'Quality Specialist', email: 'daniel.perez@company.com' },
  { id: 'user014', name: 'Jessica Torres', department: 'Quality Team', workload: 1, position: 'Quality Supervisor', email: 'jessica.torres@company.com' },
  { id: 'user015', name: 'Kevin Lee', department: 'Store Operations', workload: 3, position: 'Store Operations Specialist', email: 'kevin.lee@company.com' },
  { id: 'user016', name: 'Nicole White', department: 'Store Operations', workload: 2, position: 'Store Operations Supervisor', email: 'nicole.white@company.com' },
  { id: 'user017', name: 'Steven Clark', department: 'Task Management', workload: 4, position: 'Task Management Specialist', email: 'steven.clark@company.com' },
  { id: 'user018', name: 'Rachel Lewis', department: 'Task Management', workload: 3, position: 'Task Management Supervisor', email: 'rachel.lewis@company.com' },
  
  // Managers
  { id: 'manager001', name: 'Display Department Manager', department: 'Planogram Team', workload: 5, position: 'Department Manager', email: 'planogram.manager@company.com' },
  { id: 'manager002', name: 'Operations Department Manager', department: 'Operations Team', workload: 4, position: 'Department Manager', email: 'operations.manager@company.com' },
  { id: 'manager003', name: 'Logistics Department Manager', department: 'Logistics Team', workload: 6, position: 'Department Manager', email: 'logistics.manager@company.com' },
  { id: 'manager004', name: 'Procurement Department Manager', department: 'Procurement Team', workload: 5, position: 'Department Manager', email: 'procurement.manager@company.com' },
  { id: 'manager005', name: 'Quality Department Manager', department: 'Quality Team', workload: 4, position: 'Department Manager', email: 'quality.manager@company.com' },
  { id: 'manager006', name: 'Training Department Manager', department: 'Training Team', workload: 3, position: 'Department Manager', email: 'training.manager@company.com' },
  { id: 'manager007', name: 'Data Department Manager', department: 'Data Team', workload: 4, position: 'Department Manager', email: 'data.manager@company.com' },
  { id: 'manager008', name: 'IT Department Manager', department: 'IT Team', workload: 5, position: 'Department Manager', email: 'it.manager@company.com' },
  { id: 'manager009', name: 'Store Operations Manager', department: 'Store Operations', workload: 6, position: 'Department Manager', email: 'store.manager@company.com' },
  { id: 'manager010', name: 'Task Management Manager', department: 'Task Management', workload: 5, position: 'Department Manager', email: 'task.manager@company.com' },
  // Plan001 - Urgent Plan milestones (Completed status - all Completed)
  {
    milestoneId: 'milestone001',
    id: 'plan001',
    milestoneCode: 'M001',
    milestoneName: 'Data Collection and Analysis',
    milestoneSequence: 1,
    responsibleDepartment: 'Planogram Team',

    templateDuration: 3,
    templateBufferTime: 1,
    plannedStartTime: new Date('2025-01-10T09:00:00'),
    plannedEndTime: new Date('2025-01-12T17:00:00'),
    actualStartTime: new Date('2025-01-10T09:00:00'),
    actualEndTime: new Date('2025-01-12T17:00:00'),
    status: 'Completed',
    parallelExecution: false,
    deliverables: 'Data collection and analysis report',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone002',
    id: 'plan001',
    milestoneCode: 'M002',
    milestoneName: 'Display Solution Design',
    milestoneSequence: 2,
    responsibleDepartment: 'Planogram Team',

    templateDuration: 4,
    templateBufferTime: 1,
    plannedStartTime: new Date('2025-01-13T09:00:00'),
    plannedEndTime: new Date('2025-01-17T17:00:00'),
    actualStartTime: new Date('2025-01-13T09:00:00'),
    actualEndTime: new Date('2025-01-17T17:00:00'),
    status: 'Completed',
    parallelExecution: false,
    deliverables: 'Display solution design document',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone003',
    id: 'plan001',
    milestoneCode: 'M003',
    milestoneName: 'Solution Review and Optimization',
    milestoneSequence: 3,
    responsibleDepartment: 'Planogram Team',

    templateDuration: 4,
    templateBufferTime: 1,
    plannedStartTime: new Date('2025-01-18T09:00:00'),
    plannedEndTime: new Date('2025-01-22T17:00:00'),
    actualStartTime: new Date('2025-01-18T09:00:00'),
    actualEndTime: new Date('2025-01-22T17:00:00'),
    status: 'Completed',
    parallelExecution: false,
    deliverables: 'Optimized solution document',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone004',
    id: 'plan001',
    milestoneCode: 'M004',
    milestoneName: 'Material Preparation and Distribution',
    milestoneSequence: 4,
    responsibleDepartment: 'Planogram Team',

    templateDuration: 4,
    templateBufferTime: 1,
    plannedStartTime: new Date('2025-01-23T09:00:00'),
    plannedEndTime: new Date('2025-01-27T17:00:00'),
    actualStartTime: new Date('2025-01-23T09:00:00'),
    actualEndTime: new Date('2025-01-27T17:00:00'),
    status: 'Completed',
    parallelExecution: false,
    deliverables: 'Material distribution plan',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone005',
    id: 'plan001',
    milestoneCode: 'M005',
    milestoneName: 'Store Task Generation',
    milestoneSequence: 5,
    responsibleDepartment: 'System Auto',

    templateDuration: 1,
    templateBufferTime: 0,
    plannedStartTime: new Date('2025-01-28T09:00:00'),
    plannedEndTime: new Date('2025-01-28T18:00:00'),
    actualStartTime: new Date('2025-01-28T09:00:00'),
    actualEndTime: new Date('2025-01-28T18:00:00'),
    status: 'Completed',
    parallelExecution: false,
    deliverables: 'Store execution tasks',
    finalMilestoneFlag: true,
    subtasks: [],
  },
  {
    milestoneId: 'milestone006',
    id: 'plan001',
    milestoneCode: 'M006',
    milestoneName: 'Store Task Generation',
    milestoneSequence: 6,
    responsibleDepartment: 'System Auto',

    templateDuration: 1,
    templateBufferTime: 0,
    plannedStartTime: new Date('2025-01-29T09:00:00'),
    plannedEndTime: new Date('2025-01-29T18:00:00'),
    actualStartTime: new Date('2025-01-29T09:00:00'),
    actualEndTime: new Date('2025-01-29T18:00:00'),
    status: 'Completed',
    parallelExecution: false,
    deliverables: 'Store execution tasks',
    finalMilestoneFlag: true,
    subtasks: [],
  },
  {
    milestoneId: 'milestone007',
    id: 'plan001',
    milestoneCode: 'M007',
    milestoneName: 'Store Task Generation',
    milestoneSequence: 7,
    responsibleDepartment: 'System Auto',

    templateDuration: 1,
    templateBufferTime: 0,
    plannedStartTime: new Date('2025-01-30T09:00:00'),
    plannedEndTime: new Date('2025-01-30T18:00:00'),
    actualStartTime: new Date('2025-01-30T09:00:00'),
    actualEndTime: new Date('2025-01-30T18:00:00'),
    status: 'Completed',
    parallelExecution: false,
    deliverables: 'Store execution tasks',
    finalMilestoneFlag: true,
    subtasks: [],
  },
  {
    milestoneId: 'milestone008',
    id: 'plan001',
    milestoneCode: 'M008',
    milestoneName: 'Store Task Generation',
    milestoneSequence: 8,
    responsibleDepartment: 'System Auto',

    templateDuration: 1,
    templateBufferTime: 0,
    plannedStartTime: new Date('2025-01-31T09:00:00'),
    plannedEndTime: new Date('2025-01-31T18:00:00'),
    actualStartTime: new Date('2025-01-31T09:00:00'),
    actualEndTime: new Date('2025-01-31T18:00:00'),
    status: 'Completed',
    parallelExecution: false,
    deliverables: 'Store execution tasks',
    finalMilestoneFlag: true,
    subtasks: [],
  },
  {
    milestoneId: 'milestone009',
    id: 'plan001',
    milestoneCode: 'M009',
    milestoneName: 'Store Task Generation',
    milestoneSequence: 9,
    responsibleDepartment: 'System Auto',

    templateDuration: 1,
    templateBufferTime: 0,
    plannedStartTime: new Date('2025-02-21T09:00:00'),
    plannedEndTime: new Date('2025-02-21T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Store execution tasks',
    finalMilestoneFlag: true,
    subtasks: [],
  },

  // Plan002 - Major Plan milestones
  {
    milestoneId: 'milestone013',
    id: 'plan002',
    milestoneCode: 'M001',
    milestoneName: 'Display Group Adjustment',
    milestoneSequence: 1,
    responsibleDepartment: 'Planogram Team',

    templateDuration: 3,
    templateBufferTime: 1,
    plannedStartTime: new Date('2025-02-10T09:00:00'),
    plannedEndTime: new Date('2025-02-13T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Updated Display Group configuration',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone014',
    id: 'plan002',
    milestoneCode: 'M002',
    milestoneName: 'Store Group Setup',
    milestoneSequence: 2,
    responsibleDepartment: 'Planogram Team',

    templateDuration: 2,
    templateBufferTime: 1,
    plannedStartTime: new Date('2025-02-14T09:00:00'),
    plannedEndTime: new Date('2025-02-17T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Determined target store list',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone015',
    id: 'plan002',
    milestoneCode: 'M003',
    milestoneName: 'Benchmark Master Drawing',
    milestoneSequence: 3,
    responsibleDepartment: 'Planogram Team',

    templateDuration: 5,
    templateBufferTime: 2,
    plannedStartTime: new Date('2025-02-18T09:00:00'),
    plannedEndTime: new Date('2025-02-25T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Benchmark display diagram',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone016',
    id: 'plan002',
    milestoneCode: 'M004',
    milestoneName: 'Store Layout Adjustment',
    milestoneSequence: 4,
    responsibleDepartment: 'Construction Team',

    templateDuration: 7,
    templateBufferTime: 2,
    plannedStartTime: new Date('2025-02-26T09:00:00'),
    plannedEndTime: new Date('2025-03-07T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: true,
    deliverables: 'Updated store layout',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone017',
    id: 'plan002',
    milestoneCode: 'M005',
    milestoneName: 'Fixture Type Set Up',
    milestoneSequence: 5,
    responsibleDepartment: 'Floor Plan Team',

    templateDuration: 3,
    templateBufferTime: 1,
    plannedStartTime: new Date('2025-02-26T09:00:00'),
    plannedEndTime: new Date('2025-03-01T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: true,
    deliverables: 'New fixture type configuration',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone018',
    id: 'plan002',
    milestoneCode: 'M006',
    milestoneName: 'Display Planning Adjustment',
    milestoneSequence: 6,
    responsibleDepartment: 'Floor Plan Team',

    templateDuration: 4,
    templateBufferTime: 1,
    plannedStartTime: new Date('2025-03-08T09:00:00'),
    plannedEndTime: new Date('2025-03-12T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Updated display planning',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
     milestoneId: 'milestone019',
     id: 'plan002',
     milestoneCode: 'M007',
     milestoneName: 'Fixture Procurement',
    milestoneSequence: 7,
    responsibleDepartment: 'Procurement Team',

    templateDuration: 5,
    templateBufferTime: 2,
    plannedStartTime: new Date('2025-03-13T09:00:00'),
    plannedEndTime: new Date('2025-03-20T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Purchase orders',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone020',
    id: 'plan002',
    milestoneCode: 'M008',
    milestoneName: 'Algorithm Generated Planogram for Review',
    milestoneSequence: 8,
    responsibleDepartment: 'System Auto',

    templateDuration: 3,
    templateBufferTime: 1,
    plannedStartTime: new Date('2025-03-21T09:00:00'),
    plannedEndTime: new Date('2025-03-24T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Final display diagram',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone021',
    id: 'plan002',
    milestoneCode: 'M009',
    milestoneName: 'Store Task Generation',
    milestoneSequence: 9,
    responsibleDepartment: 'System Auto',

    templateDuration: 1,
    templateBufferTime: 0,
    plannedStartTime: new Date('2025-03-25T09:00:00'),
    plannedEndTime: new Date('2025-03-25T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Store execution tasks',
    finalMilestoneFlag: true,
    subtasks: [],
  },

  // Plan003 - Regular Plan milestones (Pending status - all NotStarted)
  {
    milestoneId: 'milestone022',
    id: 'plan003',
    milestoneCode: 'M001',
    milestoneName: 'Display Group Adjustment',
    milestoneSequence: 1,
    responsibleDepartment: 'Planogram Team',

    templateDuration: 3,
    templateBufferTime: 1,
    plannedStartTime: new Date('2025-02-01T09:00:00'),
    plannedEndTime: new Date('2025-02-04T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Updated Display Group configuration',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone023',
    id: 'plan003',
    milestoneCode: 'M002',
    milestoneName: 'Store Group Setup',
    milestoneSequence: 2,
    responsibleDepartment: 'Planogram Team',

    templateDuration: 2,
    templateBufferTime: 1,
    plannedStartTime: new Date('2025-02-05T09:00:00'),
    plannedEndTime: new Date('2025-02-07T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Determined target store list',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone024',
    id: 'plan003',
    milestoneCode: 'M003',
    milestoneName: 'Benchmark Master Drawing',
    milestoneSequence: 3,
    responsibleDepartment: 'Planogram Team',

    templateDuration: 5,
    templateBufferTime: 2,
    plannedStartTime: new Date('2025-02-08T09:00:00'),
    plannedEndTime: new Date('2025-02-15T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Benchmark display diagram',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone025',
    id: 'plan003',
    milestoneCode: 'M008',
    milestoneName: 'Algorithm Generated Planogram for Review',
    milestoneSequence: 8,
    responsibleDepartment: 'System Auto',

    templateDuration: 3,
    templateBufferTime: 1,
    plannedStartTime: new Date('2025-02-16T09:00:00'),
    plannedEndTime: new Date('2025-02-19T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Final display diagram',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone026',
    id: 'plan003',
    milestoneCode: 'M009',
    milestoneName: 'Store Task Generation',
    milestoneSequence: 9,
    responsibleDepartment: 'System Auto',

    templateDuration: 1,
    templateBufferTime: 0,
    plannedStartTime: new Date('2025-02-20T09:00:00'),
    plannedEndTime: new Date('2025-02-20T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Store execution tasks',
    finalMilestoneFlag: true,
    subtasks: [],
  },

  // Plan006 - Minor Plan milestones (Pending status - all NotStarted)
  {
    milestoneId: 'milestone027',
    id: 'plan006',
    milestoneCode: 'M001',
    milestoneName: 'Display Group Adjustment',
    milestoneSequence: 1,
    responsibleDepartment: 'Planogram Team',

    templateDuration: 3,
    templateBufferTime: 1,
    plannedStartTime: new Date('2025-02-22T09:00:00'),
    plannedEndTime: new Date('2025-02-25T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Updated Display Group configuration',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone028',
    id: 'plan006',
    milestoneCode: 'M003',
    milestoneName: 'Benchmark Master Drawing',
    milestoneSequence: 3,
    responsibleDepartment: 'Planogram Team',

    templateDuration: 2,
    templateBufferTime: 1,
    plannedStartTime: new Date('2025-02-26T09:00:00'),
    plannedEndTime: new Date('2025-02-28T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Benchmark display diagram',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone029',
    id: 'plan006',
    milestoneCode: 'M009',
    milestoneName: 'Store Task Generation',
    milestoneSequence: 9,
    responsibleDepartment: 'System Auto',

    templateDuration: 1,
    templateBufferTime: 0,
    plannedStartTime: new Date('2025-03-01T09:00:00'),
    plannedEndTime: new Date('2025-03-01T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Store execution tasks',
    finalMilestoneFlag: true,
    subtasks: [],
  },

  // Plan010 - Special Plan milestones (Pending status - all NotStarted)
  {
    milestoneId: 'milestone030',
    id: 'plan010',
    milestoneCode: 'M001',
    milestoneName: 'Display Group Adjustment',
    milestoneSequence: 1,
    responsibleDepartment: 'Planogram Team',

    templateDuration: 3,
    templateBufferTime: 1,
    plannedStartTime: new Date('2025-03-08T09:00:00'),
    plannedEndTime: new Date('2025-03-11T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Updated Display Group configuration',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone031',
    id: 'plan010',
    milestoneCode: 'M002',
    milestoneName: 'Store Group Setup',
    milestoneSequence: 2,
    responsibleDepartment: 'Planogram Team',

    templateDuration: 2,
    templateBufferTime: 1,
    plannedStartTime: new Date('2025-03-12T09:00:00'),
    plannedEndTime: new Date('2025-03-14T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Determined target store list',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone032',
    id: 'plan010',
    milestoneCode: 'M003',
    milestoneName: 'Benchmark Master Drawing',
    milestoneSequence: 3,
    responsibleDepartment: 'Planogram Team',

    templateDuration: 3,
    templateBufferTime: 1,
    plannedStartTime: new Date('2025-03-15T09:00:00'),
    plannedEndTime: new Date('2025-03-18T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Benchmark display diagram',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone033',
    id: 'plan010',
    milestoneCode: 'M005',
    milestoneName: 'Fixture Type Set Up',
    milestoneSequence: 5,
    responsibleDepartment: 'Floor Plan Team',

    templateDuration: 2,
    templateBufferTime: 1,
    plannedStartTime: new Date('2025-03-19T09:00:00'),
    plannedEndTime: new Date('2025-03-21T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'New fixture type configuration',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone034',
    id: 'plan010',
    milestoneCode: 'M008',
    milestoneName: 'Algorithm Generated Planogram for Review',
    milestoneSequence: 8,
    responsibleDepartment: 'System Auto',

    templateDuration: 2,
    templateBufferTime: 1,
    plannedStartTime: new Date('2025-03-22T09:00:00'),
    plannedEndTime: new Date('2025-03-24T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Final display diagram',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone035',
    id: 'plan010',
    milestoneCode: 'M009',
    milestoneName: 'Store Task Generation',
    milestoneSequence: 9,
    responsibleDepartment: 'System Auto',

    templateDuration: 1,
    templateBufferTime: 0,
    plannedStartTime: new Date('2025-03-25T09:00:00'),
    plannedEndTime: new Date('2025-03-25T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Store execution tasks',
    finalMilestoneFlag: true,
    subtasks: [],
  },

  // Plan007 - Urgent Plan milestones (simplified for urgent execution)
  {
    milestoneId: 'milestone010',
    id: 'plan007',
    milestoneCode: 'M001',
    milestoneName: 'Display Group Adjustment',
    milestoneSequence: 1,
    responsibleDepartment: 'Planogram Team',

    templateDuration: 1,
    templateBufferTime: 0,
    plannedStartTime: new Date('2025-02-01T09:00:00'),
    plannedEndTime: new Date('2025-02-01T18:00:00'),
    actualStartTime: new Date('2025-02-01T09:00:00'),
    actualEndTime: new Date('2025-02-01T16:30:00'),
    status: 'Completed',
    parallelExecution: false,
    deliverables: 'Emergency display group configuration',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone011',
    id: 'plan007',
    milestoneCode: 'M003',
    milestoneName: 'Benchmark Master Drawing',
    milestoneSequence: 2,
    responsibleDepartment: 'Planogram Team',

    templateDuration: 1,
    templateBufferTime: 0,
    plannedStartTime: new Date('2025-02-02T09:00:00'),
    plannedEndTime: new Date('2025-02-02T18:00:00'),
    actualStartTime: new Date('2025-02-02T09:00:00'),
    actualEndTime: new Date('2025-02-02T17:00:00'),
    status: 'Completed',
    parallelExecution: false,
    deliverables: 'Emergency display diagram',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone012',
    id: 'plan007',
    milestoneCode: 'M009',
    milestoneName: 'Store Task Generation',
    milestoneSequence: 9,
    responsibleDepartment: 'System Auto',

    templateDuration: 1,
    templateBufferTime: 0,
    plannedStartTime: new Date('2025-02-03T09:00:00'),
    plannedEndTime: new Date('2025-02-03T18:00:00'),
    actualStartTime: new Date('2025-02-03T09:00:00'),
    actualEndTime: undefined,
    status: 'InProgress',
    parallelExecution: false,
    deliverables: 'Emergency task list',
    finalMilestoneFlag: true,
    subtasks: [],
  },

  // Milestones for plan013 (Draft plan for testing activation)
  {
    milestoneId: 'milestone073',
    id: 'plan013',
    milestoneCode: 'M001',
    milestoneName: 'Store Group Setup',
    milestoneSequence: 1,
    responsibleDepartment: 'Operations Team',

    templateDuration: 3,
    templateBufferTime: 1,
    plannedStartTime: new Date('2024-02-01T09:00:00'),
    plannedEndTime: new Date('2024-02-05T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Store group configuration',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone074',
    id: 'plan013',
    milestoneCode: 'M002',
    milestoneName: 'Benchmark Master Drawing',
    milestoneSequence: 2,
    responsibleDepartment: 'Design Team',

    templateDuration: 5,
    templateBufferTime: 2,
    plannedStartTime: new Date('2024-02-06T09:00:00'),
    plannedEndTime: new Date('2024-02-12T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Master display drawings',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone075',
    id: 'plan013',
    milestoneCode: 'M003',
    milestoneName: 'Display Group Adjustment',
    milestoneSequence: 3,
    responsibleDepartment: 'Visual Merchandising Team',

    templateDuration: 6,
    templateBufferTime: 2,
    plannedStartTime: new Date('2024-02-13T09:00:00'),
    plannedEndTime: new Date('2024-02-20T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Adjusted display groups',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone076',
    id: 'plan013',
    milestoneCode: 'M004',
    milestoneName: 'Store Task Generation',
    milestoneSequence: 4,
    responsibleDepartment: 'Operations Team',

    templateDuration: 4,
    templateBufferTime: 1,
    plannedStartTime: new Date('2024-02-21T09:00:00'),
    plannedEndTime: new Date('2024-02-28T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Store execution tasks',
    finalMilestoneFlag: true,
    subtasks: [],
  },
]

// Standard milestone types (9 types) - Aligned with template management system
export const standardMilestoneTypes = [
  { sequence: 1, code: 'M001', name: 'Display Group Adjustment', department: 'Planogram Team', duration: 3, bufferTime: 1 },
  { sequence: 2, code: 'M002', name: 'Store Group Setup', department: 'Planogram Team', duration: 2, bufferTime: 1 },
  { sequence: 3, code: 'M003', name: 'Benchmark Master Drawing', department: 'Planogram Team', duration: 5, bufferTime: 2 },
  { sequence: 4, code: 'M004', name: 'Store Layout Adjustment', department: 'Construction Team', duration: 7, bufferTime: 2 },
  { sequence: 5, code: 'M005', name: 'Fixture Type Set Up', department: 'Floor Plan Team', duration: 3, bufferTime: 1 },
  { sequence: 6, code: 'M006', name: 'Display Planning Adjustment', department: 'Floor Plan Team', duration: 4, bufferTime: 1 },
  { sequence: 7, code: 'M007', name: 'Fixture Procurement', department: 'Procurement Team', duration: 5, bufferTime: 2 },
  { sequence: 8, code: 'M008', name: 'Algorithm Generated Planogram for Review', department: 'System Auto', duration: 3, bufferTime: 1 },
  { sequence: 9, code: 'M009', name: 'Store Task Generation', department: 'System Auto', duration: 1, bufferTime: 0 }
];

// Comprehensive mock data for all 5 plan types
export const mockPlans: PlanogramPlan[] = [
  // Major Plans
  {
    id: 'plan001',
    planCode: 'TEMP001_52_20250127',
    planName: 'East China Major Adjustment Plan_W52',
    planType: 'Major',
    templateReference: 'TEMP001',
    businessActivity: 'Spring Festival Promotion Display Adjustment',
    currentMilestone: 'Store Group Setup',
    status: 'InProgress',
    templateOwner: 'projectmanager001',
    storeGroupScope: 'East China Tier-1 City Stores',
    storeCount: 156,
    planGenerateTime: new Date('2025-01-05T10:30:00'),
    plannedStartTime: new Date('2025-01-10T09:00:00'),
    plannedEndTime: new Date('2025-03-15T18:00:00'),
    actualStartTime: new Date('2025-01-10T09:00:00'),
    actualEndTime: undefined,
    description: 'Major display adjustment plan for Spring Festival promotion period, involving 156 Tier-1 city stores in East China region',
    gmtCreate: new Date('2025-01-05T10:30:00'),
    gmtModified: new Date('2025-01-10T09:00:00'),
  },
  {
    id: 'plan002',
    planCode: 'TEMP001_01_20250203',
    planName: 'National Major Category Adjustment Plan_W01',
    planType: 'Major',
    templateReference: 'TEMP001',
    businessActivity: 'Major Category Structure Adjustment',
    currentMilestone: 'Pending',
    status: 'Pending',
    templateOwner: '',
    storeGroupScope: 'National Core Stores',
    storeCount: 500,
    planGenerateTime: new Date('2025-01-28T09:15:00'),
    plannedStartTime: new Date('2025-02-10T09:00:00'),
    plannedEndTime: new Date('2025-04-30T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    description: 'Major category structure adjustment for national core stores, involving re-layout of multiple categories',
    gmtCreate: new Date('2025-01-28T09:15:00'),
    gmtModified: new Date('2025-01-28T09:15:00'),
  },
  // Regular Plans
  {
    id: 'plan003',
    planCode: 'TEMP002_03_20250130',
    planName: 'South China Regular Adjustment Plan_W03',
    planType: 'Regular',
    templateReference: 'TEMP002',
    businessActivity: 'Regular Product Display Optimization',
    currentMilestone: 'Pending',
    status: 'Pending',
    templateOwner: '',
    storeGroupScope: 'South China Standard Stores',
    storeCount: 89,
    planGenerateTime: new Date('2025-01-08T14:20:00'),
    plannedStartTime: new Date('2025-02-01T09:00:00'),
    plannedEndTime: new Date('2025-02-28T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    description: 'Regular display optimization adjustment for South China standard stores',
    gmtCreate: new Date('2025-01-08T14:20:00'),
    gmtModified: new Date('2025-01-08T14:20:00'),
  },
  {
    id: 'plan004',
    planCode: 'TEMP002_05_20250210',
    planName: 'Southwest Regular Maintenance Plan_W05',
    planType: 'Regular',
    templateReference: 'TEMP002',
    businessActivity: 'Display Standardization Maintenance',
    currentMilestone: 'Display Group Adjustment',
    status: 'InProgress',
    templateOwner: 'projectmanager003',
    storeGroupScope: 'Southwest Standard Stores',
    storeCount: 67,
    planGenerateTime: new Date('2025-02-05T11:30:00'),
    plannedStartTime: new Date('2025-02-10T09:00:00'),
    plannedEndTime: new Date('2025-03-10T18:00:00'),
    actualStartTime: new Date('2025-02-10T09:00:00'),
    actualEndTime: undefined,
    description: 'Display standardization maintenance and optimization for Southwest region stores',
    gmtCreate: new Date('2025-02-05T11:30:00'),
    gmtModified: new Date('2025-02-05T11:30:00'),
  },
  // Minor Plans
  {
    id: 'plan005',
    planCode: 'TEMP003_06_20250215',
    planName: 'North China Minor Adjustment Plan_W06',
    planType: 'Minor',
    templateReference: 'TEMP003',
    businessActivity: 'Local Product Position Adjustment',
    currentMilestone: 'Benchmark Master Drawing',
    status: 'InProgress',
    templateOwner: 'projectmanager004',
    storeGroupScope: 'North China Partial Stores',
    storeCount: 23,
    planGenerateTime: new Date('2025-02-10T16:45:00'),
    plannedStartTime: new Date('2025-02-15T09:00:00'),
    plannedEndTime: new Date('2025-02-25T18:00:00'),
    actualStartTime: new Date('2025-02-15T09:00:00'),
    actualEndTime: undefined,
    description: 'Local product position fine-tuning for partial stores in North China region',
    gmtCreate: new Date('2025-02-10T16:45:00'),
    gmtModified: new Date('2025-02-10T16:45:00'),
  },
  {
    id: 'plan006',
    planCode: 'TEMP003_07_20250220',
    planName: 'Northeast Minor Optimization Plan_W07',
    planType: 'Minor',
    templateReference: 'TEMP003',
    businessActivity: 'End Cap Product Adjustment',
    currentMilestone: 'Pending',
    status: 'Pending',
    templateOwner: '',
    storeGroupScope: 'Northeast Pilot Stores',
    storeCount: 15,
    planGenerateTime: new Date('2025-02-15T13:20:00'),
    plannedStartTime: new Date('2025-02-22T09:00:00'),
    plannedEndTime: new Date('2025-03-01T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    description: 'End cap product display adjustment for Northeast pilot stores',
    gmtCreate: new Date('2025-02-15T13:20:00'),
    gmtModified: new Date('2025-02-15T13:20:00'),
  },
  // Urgent Plans
  {
    id: 'plan007',
    planCode: 'TEMP004_04_20250201',
    planName: 'North China Emergency Adjustment Plan_W04',
    planType: 'Urgent',
    templateReference: 'TEMP004',
    businessActivity: 'Emergency Product Removal',
    currentMilestone: 'Store Task Generation',
    status: 'InProgress',
    templateOwner: 'projectmanager002',
    storeGroupScope: 'North China All Stores',
    storeCount: 234,
    planGenerateTime: new Date('2025-01-30T16:45:00'),
    plannedStartTime: new Date('2025-02-01T09:00:00'),
    plannedEndTime: new Date('2025-02-05T18:00:00'),
    actualStartTime: new Date('2025-02-01T09:00:00'),
    actualEndTime: undefined,
    description: 'Display adjustment plan for emergency product removal due to quality issues',
    gmtCreate: new Date('2025-01-30T16:45:00'),
    gmtModified: new Date('2025-01-30T16:45:00'),
  },
  {
    id: 'plan008',
    planCode: 'TEMP004_08_20250225',
    planName: 'National Emergency Recall Plan_W08',
    planType: 'Urgent',
    templateReference: 'TEMP004',
    businessActivity: 'Product Emergency Recall',
    currentMilestone: 'Algorithm Generated Planogram for Review',
    status: 'InProgress',
    templateOwner: 'projectmanager005',
    storeGroupScope: 'National All Stores',
    storeCount: 1200,
    planGenerateTime: new Date('2025-02-20T08:30:00'),
    plannedStartTime: new Date('2025-02-21T09:00:00'),
    plannedEndTime: new Date('2025-02-28T18:00:00'),
    actualStartTime: new Date('2025-02-21T09:00:00'),
    actualEndTime: undefined,
    description: 'Product emergency recall and display adjustment nationwide',
    gmtCreate: new Date('2025-02-20T08:30:00'),
    gmtModified: new Date('2025-02-20T08:30:00'),
  },
  // Special Plans
  {
    id: 'plan009',
    planCode: 'TEMP005_09_20250301',
    planName: 'New Product Launch Special Plan_W09',
    planType: 'Special',
    templateReference: 'TEMP005',
    businessActivity: 'Key New Product Launch Promotion',
    currentMilestone: 'Fixture Procurement',
    status: 'InProgress',
    templateOwner: 'projectmanager006',
    storeGroupScope: 'Tier-1 City Flagship Stores',
    storeCount: 45,
    planGenerateTime: new Date('2025-02-25T10:15:00'),
    plannedStartTime: new Date('2025-03-01T09:00:00'),
    plannedEndTime: new Date('2025-03-31T18:00:00'),
    actualStartTime: new Date('2025-03-01T09:00:00'),
    actualEndTime: undefined,
    description: 'Special display promotion plan for key new products in Tier-1 city flagship stores',
    gmtCreate: new Date('2025-02-25T10:15:00'),
    gmtModified: new Date('2025-02-25T10:15:00'),
  },
  {
    id: 'plan010',
    planCode: 'TEMP005_10_20250305',
    planName: 'Festival Special Display Plan_W10',
    planType: 'Special',
    templateReference: 'TEMP005',
    businessActivity: 'Festival Theme Display',
    currentMilestone: 'Pending',
    status: 'Pending',
    templateOwner: '',
    storeGroupScope: 'Key Business District Stores',
    storeCount: 78,
    planGenerateTime: new Date('2025-03-01T14:30:00'),
    plannedStartTime: new Date('2025-03-08T09:00:00'),
    plannedEndTime: new Date('2025-03-25T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    description: 'Special theme display plan for key business district stores during festivals',
    gmtCreate: new Date('2025-03-01T14:30:00'),
    gmtModified: new Date('2025-03-01T14:30:00'),
  },
  // Draft Plans for testing activation
  {
    id: 'plan011',
    planCode: 'TEMP002_11_20250310',
    planName: 'Test Draft Plan for Activation_W11',
    planType: 'Regular',
    templateReference: 'TEMP002',
    businessActivity: 'Test Display Adjustment',
    currentMilestone: 'Pending',
    status: 'Draft',
    templateOwner: 'projectmanager001',
    storeGroupScope: 'Test Region Stores',
    storeCount: 50,
    planGenerateTime: new Date('2025-03-05T09:00:00'),
    plannedStartTime: new Date('2025-03-10T09:00:00'),
    plannedEndTime: new Date('2025-03-25T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    description: 'Test plan for activation functionality with complete assignment configuration',
    gmtCreate: new Date('2025-03-05T09:00:00'),
    gmtModified: new Date('2025-03-05T09:00:00'),
  },
  // Completed Plans
  {
    id: 'plan012',
    planCode: 'TEMP001_12_20250315',
    planName: 'Completed Major Plan_W12',
    planType: 'Major',
    templateReference: 'TEMP001',
    businessActivity: 'Completed Major Plan',
    currentMilestone: 'Store Task Generation',
    status: 'Completed',
    templateOwner: 'projectmanager001',
    storeGroupScope: 'East China Tier-1 City Stores',
    storeCount: 156,
    planGenerateTime: new Date('2025-01-05T10:30:00'),
    plannedStartTime: new Date('2025-01-10T09:00:00'),
    plannedEndTime: new Date('2025-03-15T18:00:00'),
    actualStartTime: new Date('2025-01-10T09:00:00'),
    actualEndTime: new Date('2025-03-15T18:00:00'),
    description: 'Completed major display adjustment plan for Spring Festival promotion period, involving 156 Tier-1 city stores in East China region',
    gmtCreate: new Date('2025-01-05T10:30:00'),
    gmtModified: new Date('2025-03-15T18:00:00'),
  },
  // Draft Plans
  {
    id: 'plan013',
    planCode: 'TEMP002_13_20250320',
    planName: 'Draft Plan_W13',
    planType: 'Regular',
    templateReference: 'TEMP002',
    businessActivity: '测试业务活动',
    currentMilestone: 'M001',
    status: 'Draft',
    templateOwner: '张三',
    storeGroupScope: '华东区',
    storeCount: 50,
    planGenerateTime: new Date('2024-01-15'),
    plannedStartTime: new Date('2024-02-01'),
    plannedEndTime: new Date('2024-03-01'),
    description: '用于测试激活功能的计划',
    gmtCreate: new Date('2024-01-15'),
    gmtModified: new Date('2024-01-15'),
    creatorName: '系统管理员',
    modifierName: '系统管理员'
  },
  // Cancelled Plans
  {
    id: 'plan014',
    planCode: 'TEMP001_14_20250325',
    planName: 'Cancelled Major Plan_W14',
    planType: 'Major',
    templateReference: 'TEMP001',
    businessActivity: 'Cancelled Major Plan',
    currentMilestone: 'Store Group Setup',
    status: 'Cancelled',
    templateOwner: 'projectmanager001',
    storeGroupScope: 'East China Tier-1 City Stores',
    storeCount: 156,
    planGenerateTime: new Date('2025-01-05T10:30:00'),
    plannedStartTime: new Date('2025-01-10T09:00:00'),
    plannedEndTime: new Date('2025-03-15T18:00:00'),
    actualStartTime: new Date('2025-01-10T09:00:00'),
    actualEndTime: undefined,
    description: 'Cancelled major display adjustment plan for Spring Festival promotion period, involving 156 Tier-1 city stores in East China region',
    gmtCreate: new Date('2025-01-05T10:30:00'),
    gmtModified: new Date('2025-03-25T18:00:00'),
  },
]

// Mock departments data
export const mockDepartments = [
  { id: 'dept001', name: 'Planogram Team', description: 'Display Team', headCount: 15 },
  { id: 'dept002', name: 'Operations Team', description: 'Operations Team', headCount: 20 },
  { id: 'dept003', name: 'Logistics Team', description: 'Logistics Team', headCount: 12 },
  { id: 'dept004', name: 'Procurement Team', description: 'Procurement Team', headCount: 8 },
  { id: 'dept005', name: 'Quality Team', description: 'Quality Team', headCount: 6 },
  { id: 'dept006', name: 'Training Team', description: 'Training Team', headCount: 5 },
  { id: 'dept007', name: 'Data Team', description: 'Data Team', headCount: 10 },
  { id: 'dept008', name: 'IT Team', description: 'IT Team', headCount: 8 },
  { id: 'dept009', name: 'Store Operations', description: 'Store Operations', headCount: 25 },
  { id: 'dept010', name: 'Task Management', description: 'Task Management', headCount: 7 },
]

// Mock milestones data
export const mockMilestones = [
  // Plan001 - Major Plan milestones (all 9 standard milestones)
  {
    milestoneId: 'milestone001',
    id: 'plan001',
    milestoneCode: 'M001',
    milestoneName: 'Display Group Adjustment',
    milestoneSequence: 1,
    responsibleDepartment: 'Planogram Team',

    templateDuration: 3,
    templateBufferTime: 1,
    plannedStartTime: new Date('2025-01-10T09:00:00'),
    plannedEndTime: new Date('2025-01-13T18:00:00'),
    actualStartTime: new Date('2025-01-10T09:00:00'),
    actualEndTime: new Date('2025-01-13T17:30:00'),
    status: 'Completed',
    parallelExecution: false,
    deliverables: 'Updated Display Group configuration',
    finalMilestoneFlag: false,
    subtasks: [
      mockSubtasks.find(s => s.subtaskId === 'subtask001'),
      mockSubtasks.find(s => s.subtaskId === 'subtask002'),
      mockSubtasks.find(s => s.subtaskId === 'subtask003')
    ].filter(Boolean),
  },
  {
    milestoneId: 'milestone002',
    id: 'plan001',
    milestoneCode: 'M002',
    milestoneName: 'Store Group Setup',
    milestoneSequence: 2,
    responsibleDepartment: 'Planogram Team',

    templateDuration: 2,
    templateBufferTime: 1,
    plannedStartTime: new Date('2025-01-14T09:00:00'),
    plannedEndTime: new Date('2025-01-16T18:00:00'),
    actualStartTime: new Date('2025-01-14T09:00:00'),
    actualEndTime: undefined,
    status: 'InProgress',
    parallelExecution: false,
    deliverables: 'Determined target store list',
    finalMilestoneFlag: false,
    subtasks: [
      mockSubtasks.find(s => s.subtaskId === 'subtask004'),
      mockSubtasks.find(s => s.subtaskId === 'subtask005'),
      mockSubtasks.find(s => s.subtaskId === 'subtask006')
    ].filter(Boolean),
  },
  {
    milestoneId: 'milestone003',
    id: 'plan001',
    milestoneCode: 'M003',
    milestoneName: 'Benchmark Master Drawing',
    milestoneSequence: 3,
    responsibleDepartment: 'Planogram Team',

    templateDuration: 5,
    templateBufferTime: 2,
    plannedStartTime: new Date('2025-01-17T09:00:00'),
    plannedEndTime: new Date('2025-01-24T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Benchmark display diagram',
    finalMilestoneFlag: false,
    subtasks: [
      mockSubtasks.find(s => s.subtaskId === 'subtask007'),
      mockSubtasks.find(s => s.subtaskId === 'subtask008'),
      mockSubtasks.find(s => s.subtaskId === 'subtask009')
    ].filter(Boolean),
  },
  {
    milestoneId: 'milestone004',
    id: 'plan001',
    milestoneCode: 'M004',
    milestoneName: 'Store Layout Adjustment',
    milestoneSequence: 4,
    responsibleDepartment: 'Construction Team',

    templateDuration: 7,
    templateBufferTime: 2,
    plannedStartTime: new Date('2025-01-25T09:00:00'),
    plannedEndTime: new Date('2025-02-03T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: true,
    deliverables: 'Updated store layout',
    finalMilestoneFlag: false,
    subtasks: [
      mockSubtasks.find(s => s.subtaskId === 'subtask010'),
      mockSubtasks.find(s => s.subtaskId === 'subtask011'),
      mockSubtasks.find(s => s.subtaskId === 'subtask012')
    ].filter(Boolean),
  },
  {
    milestoneId: 'milestone005',
    id: 'plan001',
    milestoneCode: 'M005',
    milestoneName: 'Fixture Type Set Up',
    milestoneSequence: 5,
    responsibleDepartment: 'Floor Plan Team',

    templateDuration: 3,
    templateBufferTime: 1,
    plannedStartTime: new Date('2025-01-25T09:00:00'),
    plannedEndTime: new Date('2025-01-28T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: true,
    deliverables: 'New fixture type configuration',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone006',
    id: 'plan001',
    milestoneCode: 'M006',
    milestoneName: 'Display Planning Adjustment',
    milestoneSequence: 6,
    responsibleDepartment: 'Floor Plan Team',

    templateDuration: 4,
    templateBufferTime: 1,
    plannedStartTime: new Date('2025-02-04T09:00:00'),
    plannedEndTime: new Date('2025-02-08T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Updated display planning',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone007',
    id: 'plan001',
    milestoneCode: 'M007',
    milestoneName: 'Fixture Procurement',
    milestoneSequence: 7,
    responsibleDepartment: 'Procurement Team',

    templateDuration: 5,
    templateBufferTime: 2,
    plannedStartTime: new Date('2025-02-09T09:00:00'),
    plannedEndTime: new Date('2025-02-16T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Purchase orders',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone008',
    id: 'plan001',
    milestoneCode: 'M008',
    milestoneName: 'Algorithm Generated Planogram for Review',
    milestoneSequence: 8,
    responsibleDepartment: 'System Auto',

    templateDuration: 3,
    templateBufferTime: 1,
    plannedStartTime: new Date('2025-02-17T09:00:00'),
    plannedEndTime: new Date('2025-02-20T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Final display diagram',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone009',
    id: 'plan001',
    milestoneCode: 'M009',
    milestoneName: 'Store Task Generation',
    milestoneSequence: 9,
    responsibleDepartment: 'System Auto',

    templateDuration: 1,
    templateBufferTime: 0,
    plannedStartTime: new Date('2025-02-21T09:00:00'),
    plannedEndTime: new Date('2025-02-21T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Store execution tasks',
    finalMilestoneFlag: true,
    subtasks: [],
  },

  // Plan002 - Major Plan milestones
  {
    milestoneId: 'milestone010',
    id: 'plan002',
    milestoneCode: 'M001',
    milestoneName: 'Display Group Adjustment',
    milestoneSequence: 1,
    responsibleDepartment: 'Planogram Team',

    templateDuration: 3,
    templateBufferTime: 1,
    plannedStartTime: new Date('2025-02-10T09:00:00'),
    plannedEndTime: new Date('2025-02-13T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Updated Display Group configuration',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone011',
    id: 'plan002',
    milestoneCode: 'M002',
    milestoneName: 'Store Group Setup',
    milestoneSequence: 2,
    responsibleDepartment: 'Planogram Team',

    templateDuration: 2,
    templateBufferTime: 1,
    plannedStartTime: new Date('2025-02-14T09:00:00'),
    plannedEndTime: new Date('2025-02-16T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Determined target store list',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone012',
    id: 'plan002',
    milestoneCode: 'M003',
    milestoneName: 'Benchmark Master Drawing',
    milestoneSequence: 3,
    responsibleDepartment: 'Planogram Team',

    templateDuration: 5,
    templateBufferTime: 2,
    plannedStartTime: new Date('2025-02-17T09:00:00'),
    plannedEndTime: new Date('2025-02-24T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Benchmark display diagram',
    finalMilestoneFlag: false,
    subtasks: [],
  },

  // Plan004 - Regular Plan milestones (InProgress)
  {
    milestoneId: 'milestone020',
    id: 'plan004',
    milestoneCode: 'M001',
    milestoneName: 'Display Group Adjustment',
    milestoneSequence: 1,
    responsibleDepartment: 'Planogram Team',

    templateDuration: 2,
    templateBufferTime: 1,
    plannedStartTime: new Date('2025-02-10T09:00:00'),
    plannedEndTime: new Date('2025-02-12T18:00:00'),
    actualStartTime: new Date('2025-02-10T09:00:00'),
    actualEndTime: new Date('2025-02-12T17:00:00'),
    status: 'Completed',
    parallelExecution: false,
    deliverables: 'Updated Display Group configuration',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone021',
    id: 'plan004',
    milestoneCode: 'M002',
    milestoneName: 'Store Group Setup',
    milestoneSequence: 2,
    responsibleDepartment: 'Planogram Team',

    templateDuration: 2,
    templateBufferTime: 1,
    plannedStartTime: new Date('2025-02-13T09:00:00'),
    plannedEndTime: new Date('2025-02-15T18:00:00'),
    actualStartTime: new Date('2025-02-13T09:00:00'),
    actualEndTime: undefined,
    status: 'InProgress',
    parallelExecution: false,
    deliverables: 'Determined target store list',
    finalMilestoneFlag: false,
    subtasks: [
      {
        subtaskId: 'subtask020',
        milestoneId: 'milestone021',
        parentMilestone: 'milestone021',
        taskName: 'Store List Verification',
        assignee: 'user020',
        creator: 'manager002',
        plannedHours: 8,
        actualHours: undefined,
        status: 'InProgress',
        startTime: new Date('2025-02-13T09:00:00'),
        endTime: undefined,
        remarks: 'Verifying store eligibility',
        deliverableFiles: [],
      },
      {
        subtaskId: 'subtask021',
        milestoneId: 'milestone021',
        parentMilestone: 'milestone021',
        taskName: 'Regional Coordination',
        assignee: 'user021',
        creator: 'manager002',
        plannedHours: 6,
        actualHours: undefined,
        status: 'NotStarted',
        startTime: undefined,
        endTime: undefined,
        remarks: 'Coordinate with regional managers',
        deliverableFiles: [],
      }
    ],
  },

  // Plan005 - Minor Plan milestones (InProgress)
  {
    milestoneId: 'milestone030',
    id: 'plan005',
    milestoneCode: 'M001',
    milestoneName: 'Display Group Adjustment',
    milestoneSequence: 1,
    responsibleDepartment: 'Planogram Team',

    templateDuration: 1,
    templateBufferTime: 0,
    plannedStartTime: new Date('2025-02-15T09:00:00'),
    plannedEndTime: new Date('2025-02-16T18:00:00'),
    actualStartTime: new Date('2025-02-15T09:00:00'),
    actualEndTime: new Date('2025-02-16T16:30:00'),
    status: 'Completed',
    parallelExecution: false,
    deliverables: 'Updated Display Group configuration',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone031',
    id: 'plan005',
    milestoneCode: 'M002',
    milestoneName: 'Store Group Setup',
    milestoneSequence: 2,
    responsibleDepartment: 'Planogram Team',

    templateDuration: 1,
    templateBufferTime: 0,
    plannedStartTime: new Date('2025-02-17T09:00:00'),
    plannedEndTime: new Date('2025-02-18T18:00:00'),
    actualStartTime: new Date('2025-02-17T09:00:00'),
    actualEndTime: new Date('2025-02-18T15:00:00'),
    status: 'Completed',
    parallelExecution: false,
    deliverables: 'Determined target store list',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone032',
    id: 'plan005',
    milestoneCode: 'M003',
    milestoneName: 'Benchmark Master Drawing',
    milestoneSequence: 3,
    responsibleDepartment: 'Planogram Team',

    templateDuration: 2,
    templateBufferTime: 1,
    plannedStartTime: new Date('2025-02-19T09:00:00'),
    plannedEndTime: new Date('2025-02-21T18:00:00'),
    actualStartTime: new Date('2025-02-19T09:00:00'),
    actualEndTime: undefined,
    status: 'InProgress',
    parallelExecution: false,
    deliverables: 'Benchmark display diagram',
    finalMilestoneFlag: false,
    subtasks: [
      {
        subtaskId: 'subtask030',
        milestoneId: 'milestone032',
        parentMilestone: 'milestone032',
        taskName: 'Product Position Analysis',
        assignee: 'user030',
        creator: 'manager003',
        plannedHours: 12,
        actualHours: undefined,
        status: 'InProgress',
        startTime: new Date('2025-02-19T09:00:00'),
        endTime: undefined,
        remarks: 'Analyzing optimal product positions',
        deliverableFiles: [],
      },
      {
        subtaskId: 'subtask031',
        milestoneId: 'milestone032',
        parentMilestone: 'milestone032',
        taskName: 'Drawing Creation',
        assignee: 'user031',
        creator: 'manager003',
        plannedHours: 8,
        actualHours: undefined,
        status: 'NotStarted',
        startTime: undefined,
        endTime: undefined,
        remarks: 'Create detailed drawings',
        deliverableFiles: [],
      }
    ],
  },

  // Plan007 - Urgent Plan milestones (InProgress)
  {
    milestoneId: 'milestone040',
    id: 'plan007',
    milestoneCode: 'M001',
    milestoneName: 'Problem Assessment',
    milestoneSequence: 1,
    responsibleDepartment: 'Quality Team',

    templateDuration: 1,
    templateBufferTime: 0,
    plannedStartTime: new Date('2025-02-01T09:00:00'),
    plannedEndTime: new Date('2025-02-01T18:00:00'),
    actualStartTime: new Date('2025-02-01T09:00:00'),
    actualEndTime: new Date('2025-02-01T16:30:00'),
    status: 'Completed',
    parallelExecution: false,
    deliverables: 'Problem assessment report',
    finalMilestoneFlag: false,
    subtasks: [
      mockSubtasks.find(s => s.subtaskId === 'subtask013'),
      mockSubtasks.find(s => s.subtaskId === 'subtask014')
    ].filter(Boolean),
  },
  {
    milestoneId: 'milestone041',
    id: 'plan007',
    milestoneCode: 'M002',
    milestoneName: 'Emergency Solution Design',
    milestoneSequence: 2,
    responsibleDepartment: 'Planogram Team',

    templateDuration: 1,
    templateBufferTime: 0,
    plannedStartTime: new Date('2025-02-02T09:00:00'),
    plannedEndTime: new Date('2025-02-02T18:00:00'),
    actualStartTime: new Date('2025-02-02T09:00:00'),
    actualEndTime: new Date('2025-02-02T17:00:00'),
    status: 'Completed',
    parallelExecution: false,
    deliverables: 'Emergency solution plan',
    finalMilestoneFlag: false,
    subtasks: [
      mockSubtasks.find(s => s.subtaskId === 'subtask015'),
      mockSubtasks.find(s => s.subtaskId === 'subtask016')
    ].filter(Boolean),
  },
  {
    milestoneId: 'milestone042',
    id: 'plan007',
    milestoneCode: 'M003',
    milestoneName: 'Store Task Generation',
    milestoneSequence: 3,
    responsibleDepartment: 'System Auto',

    templateDuration: 1,
    templateBufferTime: 0,
    plannedStartTime: new Date('2025-02-03T09:00:00'),
    plannedEndTime: new Date('2025-02-03T18:00:00'),
    actualStartTime: new Date('2025-02-03T09:00:00'),
    actualEndTime: undefined,
    status: 'InProgress',
    parallelExecution: false,
    deliverables: 'Store execution tasks',
    finalMilestoneFlag: true,
    subtasks: [
      mockSubtasks.find(s => s.subtaskId === 'subtask017'),
      mockSubtasks.find(s => s.subtaskId === 'subtask018')
    ].filter(Boolean),
  },

  // Plan008 - Urgent Plan milestones (InProgress)
  {
    milestoneId: 'milestone050',
    id: 'plan008',
    milestoneCode: 'M001',
    milestoneName: 'Recall Assessment',
    milestoneSequence: 1,
    responsibleDepartment: 'Quality Team',

    templateDuration: 1,
    templateBufferTime: 0,
    plannedStartTime: new Date('2025-02-21T09:00:00'),
    plannedEndTime: new Date('2025-02-21T18:00:00'),
    actualStartTime: new Date('2025-02-21T09:00:00'),
    actualEndTime: new Date('2025-02-21T15:00:00'),
    status: 'Completed',
    parallelExecution: false,
    deliverables: 'Recall scope assessment',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone051',
    id: 'plan008',
    milestoneCode: 'M002',
    milestoneName: 'Algorithm Generated Planogram for Review',
    milestoneSequence: 2,
    responsibleDepartment: 'System Auto',

    templateDuration: 2,
    templateBufferTime: 1,
    plannedStartTime: new Date('2025-02-22T09:00:00'),
    plannedEndTime: new Date('2025-02-24T18:00:00'),
    actualStartTime: new Date('2025-02-22T09:00:00'),
    actualEndTime: undefined,
    status: 'InProgress',
    parallelExecution: false,
    deliverables: 'Updated display diagrams',
    finalMilestoneFlag: false,
    subtasks: [
      {
        subtaskId: 'subtask040',
        milestoneId: 'milestone051',
        parentMilestone: 'milestone051',
        taskName: 'Product Removal Planning',
        assignee: 'user040',
        creator: 'manager008',
        plannedHours: 16,
        actualHours: undefined,
        status: 'InProgress',
        startTime: new Date('2025-02-22T09:00:00'),
        endTime: undefined,
        remarks: 'Planning product removal strategy',
        deliverableFiles: [],
      },
      {
        subtaskId: 'subtask041',
        milestoneId: 'milestone051',
        parentMilestone: 'milestone051',
        taskName: 'Alternative Display Design',
        assignee: 'user041',
        creator: 'manager008',
        plannedHours: 12,
        actualHours: undefined,
        status: 'NotStarted',
        startTime: undefined,
        endTime: undefined,
        remarks: 'Design alternative displays',
        deliverableFiles: [],
      }
    ],
  },

  // Plan009 - Special Plan milestones (InProgress)
  {
    milestoneId: 'milestone060',
    id: 'plan009',
    milestoneCode: 'M001',
    milestoneName: 'Product Launch Planning',
    milestoneSequence: 1,
    responsibleDepartment: 'Marketing Team',

    templateDuration: 3,
    templateBufferTime: 1,
    plannedStartTime: new Date('2025-03-01T09:00:00'),
    plannedEndTime: new Date('2025-03-04T18:00:00'),
    actualStartTime: new Date('2025-03-01T09:00:00'),
    actualEndTime: new Date('2025-03-04T16:00:00'),
    status: 'Completed',
    parallelExecution: false,
    deliverables: 'Product launch strategy',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone061',
    id: 'plan009',
    milestoneCode: 'M002',
    milestoneName: 'Fixture Procurement',
    milestoneSequence: 2,
    responsibleDepartment: 'Procurement Team',

    templateDuration: 5,
    templateBufferTime: 2,
    plannedStartTime: new Date('2025-03-05T09:00:00'),
    plannedEndTime: new Date('2025-03-12T18:00:00'),
    actualStartTime: new Date('2025-03-05T09:00:00'),
    actualEndTime: undefined,
    status: 'InProgress',
    parallelExecution: false,
    deliverables: 'Special fixtures for new products',
    finalMilestoneFlag: false,
    subtasks: [
      {
        subtaskId: 'subtask050',
        milestoneId: 'milestone061',
        parentMilestone: 'milestone061',
        taskName: 'Special Fixture Design',
        assignee: 'user050',
        creator: 'manager007',
        plannedHours: 24,
        actualHours: undefined,
        status: 'InProgress',
        startTime: new Date('2025-03-05T09:00:00'),
        endTime: undefined,
        remarks: 'Designing custom fixtures for new products',
        deliverableFiles: [],
      },
      {
        subtaskId: 'subtask051',
        milestoneId: 'milestone061',
        parentMilestone: 'milestone061',
        taskName: 'Supplier Negotiation',
        assignee: 'user051',
        creator: 'manager007',
        plannedHours: 16,
        actualHours: undefined,
        status: 'NotStarted',
        startTime: undefined,
        endTime: undefined,
        remarks: 'Negotiate with fixture suppliers',
        deliverableFiles: [],
      }
    ],
  },

  // Plan003 - Regular Plan milestones (Pending)
  {
    milestoneId: 'milestone062',
    id: 'plan003',
    milestoneCode: 'M001',
    milestoneName: 'Store Group Setup',
    milestoneSequence: 1,
    responsibleDepartment: 'Operations Team',

    templateDuration: 3,
    templateBufferTime: 1,
    plannedStartTime: new Date('2025-02-01T09:00:00'),
    plannedEndTime: new Date('2025-02-05T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Store group configuration',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone063',
    id: 'plan003',
    milestoneCode: 'M002',
    milestoneName: 'Benchmark Master Drawing',
    milestoneSequence: 2,
    responsibleDepartment: 'Design Team',

    templateDuration: 5,
    templateBufferTime: 2,
    plannedStartTime: new Date('2025-02-06T09:00:00'),
    plannedEndTime: new Date('2025-02-12T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Master display drawings',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone064',
    id: 'plan003',
    milestoneCode: 'M003',
    milestoneName: 'Display Group Adjustment',
    milestoneSequence: 3,
    responsibleDepartment: 'Visual Merchandising Team',

    templateDuration: 6,
    templateBufferTime: 2,
    plannedStartTime: new Date('2025-02-13T09:00:00'),
    plannedEndTime: new Date('2025-02-20T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Adjusted display groups',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone065',
    id: 'plan003',
    milestoneCode: 'M004',
    milestoneName: 'Store Task Generation',
    milestoneSequence: 4,
    responsibleDepartment: 'Operations Team',

    templateDuration: 4,
    templateBufferTime: 1,
    plannedStartTime: new Date('2025-02-21T09:00:00'),
    plannedEndTime: new Date('2025-02-28T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Store execution tasks',
    finalMilestoneFlag: true,
    subtasks: [],
  },

  // Plan006 - Minor Plan milestones (Pending)
  {
    milestoneId: 'milestone066',
    id: 'plan006',
    milestoneCode: 'M001',
    milestoneName: 'Store Group Setup',
    milestoneSequence: 1,
    responsibleDepartment: 'Operations Team',

    templateDuration: 2,
    templateBufferTime: 1,
    plannedStartTime: new Date('2025-02-22T09:00:00'),
    plannedEndTime: new Date('2025-02-24T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Store group configuration',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone067',
    id: 'plan006',
    milestoneCode: 'M002',
    milestoneName: 'Benchmark Master Drawing',
    milestoneSequence: 2,
    responsibleDepartment: 'Design Team',

    templateDuration: 2,
    templateBufferTime: 1,
    plannedStartTime: new Date('2025-02-25T09:00:00'),
    plannedEndTime: new Date('2025-02-27T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Master display drawings',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone068',
    id: 'plan006',
    milestoneCode: 'M003',
    milestoneName: 'Store Task Generation',
    milestoneSequence: 3,
    responsibleDepartment: 'Operations Team',

    templateDuration: 2,
    templateBufferTime: 1,
    plannedStartTime: new Date('2025-02-28T09:00:00'),
    plannedEndTime: new Date('2025-03-01T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Store execution tasks',
    finalMilestoneFlag: true,
    subtasks: [],
  },

  // Plan010 - Special Plan milestones (Pending)
  {
    milestoneId: 'milestone069',
    id: 'plan010',
    milestoneCode: 'M001',
    milestoneName: 'Store Group Setup',
    milestoneSequence: 1,
    responsibleDepartment: 'Operations Team',

    templateDuration: 3,
    templateBufferTime: 1,
    plannedStartTime: new Date('2025-03-08T09:00:00'),
    plannedEndTime: new Date('2025-03-12T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Store group configuration',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone070',
    id: 'plan010',
    milestoneCode: 'M002',
    milestoneName: 'Fixture Procurement',
    milestoneSequence: 2,
    responsibleDepartment: 'Procurement Team',

    templateDuration: 4,
    templateBufferTime: 1,
    plannedStartTime: new Date('2025-03-13T09:00:00'),
    plannedEndTime: new Date('2025-03-18T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Festival theme fixtures',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone071',
    id: 'plan010',
    milestoneCode: 'M003',
    milestoneName: 'Algorithm Generated Planogram for Review',
    milestoneSequence: 3,
    responsibleDepartment: 'Design Team',

    templateDuration: 5,
    templateBufferTime: 2,
    plannedStartTime: new Date('2025-03-19T09:00:00'),
    plannedEndTime: new Date('2025-03-25T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Festival display diagrams',
    finalMilestoneFlag: false,
    subtasks: [],
  },
  {
    milestoneId: 'milestone072',
    id: 'plan010',
    milestoneCode: 'M004',
    milestoneName: 'Store Task Generation',
    milestoneSequence: 4,
    responsibleDepartment: 'Operations Team',

    templateDuration: 4,
    templateBufferTime: 1,
    plannedStartTime: new Date('2025-03-26T09:00:00'),
    plannedEndTime: new Date('2025-03-31T18:00:00'),
    actualStartTime: undefined,
    actualEndTime: undefined,
    status: 'NotStarted',
    parallelExecution: false,
    deliverables: 'Store execution tasks',
    finalMilestoneFlag: true,
    subtasks: [],
  },
]

// Mock API Services following POST/GET request pattern
export class MockPlanService {
  static async getPlanDetails(id: string) {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 500))
    
    const plan = mockPlans.find(p => p.id === id)
    if (!plan) {
      throw new Error(`Plan with ID ${id} not found`)
    }
    
    return {
      success: true,
      data: plan,
      message: 'Plan details retrieved successfully'
    }
  }

  static async getPlanList(filters?: {
    status?: string[]
    planType?: string[]
    templateOwner?: string
    dateRange?: [string, string]
    searchKeyword?: string
    page?: number
    pageSize?: number
  }) {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 800))
    
    let filteredPlans = [...mockPlans]
    
    // Apply filters
    if (filters?.status && filters.status.length > 0) {
      filteredPlans = filteredPlans.filter(plan => filters.status!.includes(plan.status))
    }
    
    if (filters?.planType && filters.planType.length > 0) {
      filteredPlans = filteredPlans.filter(plan => filters.planType!.includes(plan.planType))
    }
    
    if (filters?.templateOwner) {
      filteredPlans = filteredPlans.filter(plan => 
        plan.templateOwner.toLowerCase().includes(filters.templateOwner!.toLowerCase())
      )
    }
    
    if (filters?.searchKeyword) {
      const keyword = filters.searchKeyword.toLowerCase()
      filteredPlans = filteredPlans.filter(plan => 
        plan.planName.toLowerCase().includes(keyword) ||
        plan.planCode.toLowerCase().includes(keyword) ||
        plan.businessActivity.toLowerCase().includes(keyword)
      )
    }
    
    if (filters?.dateRange && filters.dateRange[0] && filters.dateRange[1]) {
      const startDate = new Date(filters.dateRange[0])
      const endDate = new Date(filters.dateRange[1])
      filteredPlans = filteredPlans.filter(plan => {
        const planDate = plan.plannedStartTime
        return planDate >= startDate && planDate <= endDate
      })
    }
    
    // Pagination
    const page = filters?.page || 1
    const pageSize = filters?.pageSize || 10
    const startIndex = (page - 1) * pageSize
    const endIndex = startIndex + pageSize
    const paginatedPlans = filteredPlans.slice(startIndex, endIndex)
    
    return {
      success: true,
      data: {
        plans: paginatedPlans,
        total: filteredPlans.length,
        page,
        pageSize,
        totalPages: Math.ceil(filteredPlans.length / pageSize)
      },
      message: 'Plan list retrieved successfully'
    }
  }

  static async activatePlan(id: string, formData?: any) {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 1000))
    
    const planIndex = mockPlans.findIndex(p => p.id === id)
    if (planIndex === -1) {
      throw new Error(`Plan with ID ${id} not found`)
    }
    
    // Update plan status
    mockPlans[planIndex].status = 'InProgress'
    mockPlans[planIndex].actualStartTime = new Date()
    
    // 如果有表单数据，则更新计划的plannedStartTime和description
    if (formData) {
      if (formData.plannedStartTime) {
        // 如果plannedStartTime是时间戳，则转换为Date对象
        if (typeof formData.plannedStartTime === 'number') {
          mockPlans[planIndex].plannedStartTime = new Date(formData.plannedStartTime);
        } else {
          mockPlans[planIndex].plannedStartTime = formData.plannedStartTime;
        }
      }
      if (formData.description !== undefined) {
        mockPlans[planIndex].description = formData.description;
      }
    }
    
    return {
      success: true,
      data: mockPlans[planIndex],
      message: 'Plan activated successfully'
    }
  }

  static async pausePlan(id: string) {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 800))
    
    const planIndex = mockPlans.findIndex(p => p.id === id)
    if (planIndex === -1) {
      throw new Error(`Plan with ID ${id} not found`)
    }
    
    // Update plan status
    mockPlans[planIndex].status = 'Paused'
    
    return {
      success: true,
      data: mockPlans[planIndex],
      message: 'Plan paused successfully'
    }
  }

  static async cancelPlan(id: string) {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 800))
    
    const planIndex = mockPlans.findIndex(p => p.id === id)
    if (planIndex === -1) {
      throw new Error(`Plan with ID ${id} not found`)
    }
    
    // Update plan status
    mockPlans[planIndex].status = 'Cancelled'
    
    return {
      success: true,
      data: mockPlans[planIndex],
      message: 'Plan cancelled successfully'
    }
  }

  static async getStatistics() {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 600))
    
    const stats = {
      totalPlans: mockPlans.length,
      activePlans: mockPlans.filter(p => p.status === 'InProgress').length,
      pendingPlans: mockPlans.filter(p => p.status === 'Pending').length,
      completedPlans: mockPlans.filter(p => p.status === 'Completed').length,
      cancelledPlans: mockPlans.filter(p => p.status === 'Cancelled').length,
      pausedPlans: mockPlans.filter(p => p.status === 'Paused').length,
    }
    
    return {
      success: true,
      data: stats,
      message: 'Statistics retrieved successfully'
    }
  }
}

export class MockAssignmentService {
  private static delay(ms: number = 500): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  private static generateTraceId(): string {
    return `trace_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  }

  // GET assignment data for a plan
  static async getAssignmentData(id: string) {
    await this.delay();

    const plan = mockPlans.find(p => p.id === id);
    if (!plan) {
      return {
        success: false,
        errorMessage: '计划不存在',
        errorCode: 'PLAN_NOT_FOUND',
        traceId: this.generateTraceId(),
        flag: 'fail' as const
      };
    }

    const planMilestones = mockMilestones.filter(m => m.id === id);
    const assignmentData = {
      id,
      assignments: planMilestones.map(milestone => ({
        milestoneId: milestone.milestoneId,
        subtasks: mockSubtasks
          .filter(s => s.milestoneId === milestone.milestoneId)
          .map(subtask => ({
            taskName: subtask.taskName,
            assignee: subtask.assignee,
            plannedCompletionTime: subtask.endTime || new Date(),
            requiresFiles: subtask.deliverableFiles.length > 0,
            description: ''
          }))
      }))
    };

    return {
      success: true,
      data: assignmentData,
      traceId: this.generateTraceId(),
      flag: 'success' as const
    };
  }

  // POST save assignment configuration
  static async saveAssignment(params: any) {
    await this.delay();

    // Handle both direct assignment data and wrapped params
    const assignmentData = params.assignments ? params : { id: params.id, assignments: [] };

    // Validate plan exists
    const plan = mockPlans.find(p => p.id === assignmentData.id);
    if (!plan) {
      return {
        success: false,
        errorMessage: '计划不存在',
        errorCode: 'PLAN_NOT_FOUND',
        traceId: this.generateTraceId(),
        flag: 'fail' as const
      };
    }

    return {
      success: true,
      data: assignmentData,
      traceId: this.generateTraceId(),
      flag: 'success' as const
    };
  }

  // POST validate assignment configuration
  static async validateAssignment(params: any) {
    await this.delay();

    const errors: any[] = [];
    const assignmentData = params.assignments ? params : { id: params.id, assignments: [] };
    const planMilestones = mockMilestones.filter(m => m.id === assignmentData.id);

    // Validate each milestone has subtasks
    planMilestones.forEach(milestone => {
      const assignment = assignmentData.assignments?.find((a: any) => a.milestoneId === milestone.milestoneId);
      
      // Skip subtask validation for "Store Task Generation" milestone
      if (milestone.milestoneName !== 'Store Task Generation') {
        if (!assignment || !assignment.subtasks || assignment.subtasks.length === 0) {
          errors.push({
            field: `milestone_${milestone.milestoneId}`,
            message: `里程碑"${milestone.milestoneName}"缺少子任务`,
            type: 'required'
          });
        }
        
        // Validate subtasks
        assignment?.subtasks?.forEach((subtask: any, index: number) => {
          if (!subtask.taskName) {
            errors.push({
              field: `subtask_${milestone.milestoneId}_${index}`,
              message: `里程碑"${milestone.milestoneName}"的第${index + 1}个子任务缺少任务名称`,
              type: 'required'
            });
          }
          
          if (!subtask.assignee) {
            errors.push({
              field: `subtask_${milestone.milestoneId}_${index}`,
              message: `里程碑"${milestone.milestoneName}"的第${index + 1}个子任务缺少负责人`,
              type: 'required'
            });
          }
        });
      }
    });

    return {
      success: true,
      data: {
        isValid: errors.length === 0,
        errors
      },
      traceId: this.generateTraceId(),
      flag: 'success' as const
    };
  }

  // POST submit assignment configuration
  static async submitAssignment(params: any) {
    await this.delay();

    const assignmentData = params.assignments ? params : { id: params.id, assignments: [] };
    
    // Validate first
    const validation = await this.validateAssignment(assignmentData);
    if (!validation.success || !validation.data.isValid) {
      return validation;
    }
    
    return {
      success: true,
      data: assignmentData,
      traceId: this.generateTraceId(),
      flag: 'success' as const
    };
  }

  static async getAvailablePersonnel() {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 400))
    
    return {
      success: true,
      data: mockPersonnel,
      message: 'Available personnel retrieved successfully'
    }
  }

  static async getAvailableDepartments() {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 300))
    
    return {
      success: true,
      data: mockDepartments,
      message: 'Available departments retrieved successfully'
    }
  }
}

export class MockMilestoneService {
  static async getMilestoneDetails(milestoneId: string) {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 500))
    
    const milestone = mockMilestones.find(m => m.milestoneId === milestoneId)
    if (!milestone) {
      throw new Error(`Milestone with ID ${milestoneId} not found`)
    }
    
    return {
      success: true,
      data: milestone,
      message: 'Milestone details retrieved successfully'
    }
  }

  static async getMilestonesByPlan(params: { Id: string }) {
    // Simulate API delay
    await new Promise(resolve => setTimeout(resolve, 600))
    
    const planMilestones = mockMilestones.filter(m => m.id === params.Id)
    
    return {
      success: true,
      data: planMilestones,
      message: 'Plan milestones retrieved successfully'
    }
  }
}

// Export mock data and services
export const mockData = {
  files: mockFiles,
  subtasks: mockSubtasks,
  personnel: mockPersonnel,
  departments: mockDepartments,
  milestones: mockMilestones,
  plans: mockPlans,
  standardMilestoneTypes
}

export const mockServices = {
  PlanService: MockPlanService,
  AssignmentService: MockAssignmentService,
  MilestoneService: MockMilestoneService
}

// Export all mock data
export {
  MOCK_PLANOGRAM_TEMPLATES,
  SAMPLE_TEMPLATES,
  generateMockTemplates
} from './planogramTemplateData';

export {
  MOCK_MILESTONE_TYPES,
  MILESTONE_TYPES_BY_CATEGORY,
  MILESTONE_TYPES_BY_TEAM,
  FINAL_MILESTONE_TYPE
} from './milestoneTypeData';

export {
  MOCK_STORE_GROUPS,
  MOCK_STORES,
  STORES_BY_FORMAT,
  STORE_STATISTICS
} from './storeData';

export {
  MOCK_BUSINESS_ACTIVITIES,
  MOCK_CREATORS,
  MOCK_REGIONS,
  MOCK_STORE_TYPES,
  MOCK_STORE_FORMATS,
  MOCK_TEMPLATE_CATEGORIES,
  MOCK_VALIDATION_RULES,
  REFERENCE_DATA
} from './referenceData';